/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const ManageRegistryIcon = ({
  title = 'ManageRegistry',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 30 24" {...props}>
    {/* prettier-ignore */}
    <g fill="none" fillRule="nonzero"><path d="M0 0h30v30H0z"/><g fill="currentColor"><path d="M2 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5H2zM2 11h4a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2v-8a2 2 0 012-2zM12.91 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4zm0-1.5h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2v-8a2 2 0 012-2zM24 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4zm0-1.5h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2v-8a2 2 0 012-2zM14.91 6.59a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.93-1.75H.762A.756.756 0 010 4.09c0-.413.341-.75.763-.75h10.216a4.001 4.001 0 017.86 0h10.398c.422 0 .763.337.763.75 0 .415-.341.75-.763.75H18.84a4.001 4.001 0 01-7.86 0z"/></g></g>
  </CreateIconComponent>
);

export default ManageRegistryIcon;
